import { render, staticRenderFns } from "./AthleteSettingsSubscriptionForm.vue?vue&type=template&id=07f3f37b&scoped=true&"
import script from "./AthleteSettingsSubscriptionForm.vue?vue&type=script&lang=ts&"
export * from "./AthleteSettingsSubscriptionForm.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteSettingsSubscriptionForm.vue?vue&type=style&index=0&id=07f3f37b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f3f37b",
  null
  
)

export default component.exports